export default __webpack_public_path__ + "static/media/gps.9ec9277f.svg";